import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Composant pour protéger les routes accessibles uniquement aux étudiants
const StudentRoute = () => {
  const { isAuthenticated, isStudent, loading } = useAuth();
  const location = useLocation();
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas authentifié
  if (!isAuthenticated) {
    // Stocker l'URL actuelle pour redirection après login si c'est une page de signature
    if (location.pathname.startsWith('/signature/')) {
      const attendanceId = location.pathname.split('/signature/')[1];
      sessionStorage.setItem('redirectAfterLogin', location.pathname);
      return <Navigate to={`/sign-in?attendanceId=${attendanceId}`} replace />;
    }
    return <Navigate to="/sign-in" replace />;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas étudiant
  if (!isStudent) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Rendre les routes enfants si l'utilisateur est étudiant
  return <Outlet />;
};

export default StudentRoute;
